angular.module('logbook')
  .factory('textOverflow', ['$timeout', function($timeout) {
    var service = {};
    
    service.checkTextOverflows = function(ids, elementPrefix, overflowIds)
    {
       $timeout(function() {
          $timeout(function() {
             ids.forEach(function(id) {
                $(elementPrefix + id).find('img').on('load', function() {
                   $timeout(function() {
                      overflowIds[id] = service.overflows(id, elementPrefix);
                   });
                });
                overflowIds[id] = service.overflows(id, elementPrefix);
             });
          })});
    };
    
    service.overflows = function(id, elementPrefix)
    {
       return $(elementPrefix + id).prop('scrollHeight')
          > $(elementPrefix + id).prop('clientHeight');
    };

    service.toggleExtraText = function(id, elementPrefix, togglePrefix, expandedIds, overflowIds, maxNoteHeight)
    {
       var isExpanded = expandedIds[id];
       $(togglePrefix + id).text(isExpanded ? 'Show More' : 'Show Less');
       $(elementPrefix + id).css('max-height', isExpanded ? (maxNoteHeight+'em') : '');
       expandedIds[id] = !isExpanded;
       if( overflowIds )
          service.checkTextOverflows([id], elementPrefix, overflowIds);
    };
    
    return service;
  }]);
